import * as React from 'react'

function IconStart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={106}
      height={62}
      viewBox="0 0 106 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#prefix__clip0)" fill="#219321">
        <path d="M12.9 2.53l36.63 21.15c5.73 3.31 5.73 11.58 0 14.89L12.9 59.71C7.16 63.02 0 58.88 0 52.26V9.97C0 3.35 7.16-.78 12.9 2.53z" />
        <path d="M57.36 2.53l36.63 21.15c5.73 3.31 5.73 11.58 0 14.89L57.36 59.71c-5.73 3.31-12.9-.83-12.9-7.45V9.97c0-6.62 7.17-10.75 12.9-7.44z" />
        <path d="M97.34 61.85a8.41 8.41 0 01-8.41-8.41V8.41A8.41 8.41 0 0197.34 0a8.41 8.41 0 018.41 8.41v45.03a8.41 8.41 0 01-8.41 8.41z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" d="M0 0h105.75v61.85H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconStart
